import { Business, Address } from 'models/business';

const defaultAddress: Address = {
  street1: '',
  street2: '',
  city: '',
  state: '',
  country: '',
  zip: '',
};

const initData: Business = {
  id: '',
  name: '',
  suggested: [],
  bankName: '',
  entityType: '',
  ein: '',
  accountId: '',
  organizationId: '',
  payroll: {
    estimatedSalary: 0,
    ytdOfficerWages: 0,
    ytdNonOfficerWages: 0,
    lyOfficerWages: 0,
    lyNonOfficerWages: 0,
  },
  hasBankAccount: false,
  disabledPayroll: false,
  hasEIN: false,
  progress: [],
  businessAddress: defaultAddress,
  mailingAddress: defaultAddress,
};

export const useCompanyDataForAdminPage = (
  businessData: Business | undefined,
): Business => {
  if (!businessData) {
    return initData;
  }

  const result = { ...initData, ...businessData };

  result.suggested = (result?.suggested ?? []).map((item: any) => item.name);

  return result;
};
